import { ReactNode } from "react";
import { SearchBarSearchParams } from "../search-bar/SearchBarSearchParams";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../search-bar/SearchBar";

const ConfigurationShell = ({
  searchItems,
  onSearch,
  title,
  onAddButtonClick,
  addButtonLabel,
  addButtonClassName,
  sideBoxShown,
  hideSearchButton = false,
  upsertComponent,
  showBackButton = true,
  gridComponent,
  allowUpsert = true,
  previousPage,
  onNavigateBack,
  canModify = true,
  hideDropdown = false,
  auxillaryAddButton = false,
  primaryAddButton = true,
  addButtonLabelClassname,
  altFilter,
}: {
  searchItems?: string[];
  onSearch?: (searchParams: SearchBarSearchParams) => void;
  title: string;
  sideBoxShown: boolean;
  addButtonLabel?: string;
  showBackButton?: boolean;
  addButtonClassName?: string;
  hideSearchButton?: boolean;
  onAddButtonClick?: () => void;
  upsertComponent: ReactNode | (() => JSX.Element);
  gridComponent: ReactNode | (() => JSX.Element);
  allowUpsert?: boolean;
  previousPage?: string;
  onNavigateBack?: () => void;
  canModify?: boolean;
  hideDropdown?: boolean;
  auxillaryAddButton?: boolean;
  primaryAddButton?: boolean;
  addButtonLabelClassname?: string;
  altFilter?: ReactNode | (() => JSX.Element);
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-1 flex-col h-full ">
      <div className="flex flex-row justify-between items-center pl-4 pr-6 min-h-1/6 top-bar w-full">
        {!(hideSearchButton && !showBackButton) && (
          <div className="flex-col  ">
            {showBackButton && (
              <button type="button"
                onClick={() => {
                  onNavigateBack ? onNavigateBack() : navigate(-1);
                }}
                className="tpr-name text-white pt-6 pb-2 text-lg flex cursor-pointer items-center"
              >
                <ArrowBackIosNewIcon />
                <p className="pl-4">
                  {previousPage
                    ? t("labels.back-to") + t(`${previousPage}`)
                    : t(
                        "modules.configuration.customers.details.back-to-configuration"
                      )}
                </p>
              </button>
            )}
            <p className="text-3xl font-semibold text-white pl-10">
              {t(title)}
            </p>
          </div>
        )}
        {(!!onAddButtonClick || !sideBoxShown) &&
          allowUpsert &&
          auxillaryAddButton &&
          canModify && (
            <button type="button"
              className={` flex items-center flex-row gap-2 ${
                addButtonClassName ??
                "text-white border-[#FFFFFF20] border-2 bg-[#FFFFFF20]  px-6 py-8 rounded-lg"
              } h-12 z-10 mr-2`}
              onClick={onAddButtonClick}
            >
              <AddIcon
                sx={{
                  "&": {
                    color: "white",
                    cursor: "pointer",
                  },
                }}
                fontSize="large"
              />
              {!!addButtonLabel && (
                <span
                  className={` ${
                    addButtonLabelClassname ?? "text-white text-base"
                  } font-semibold`}
                >
                  {t(addButtonLabel)}
                </span>
              )}
            </button>
          )}
      </div>
      <div
        className={`card rounded-md flex flex-grow overflow-hidden relative`}
      >
        <div className="card__left mr-4 rounded-md bg-white">
          <div className="card__left__filters flex justify-between h-full flex-1 ">
            {hideSearchButton || !onSearch ? (
              <div></div>
            ) : (
              <div className="z-50">
                <SearchBar
                  searchList={searchItems || []}
                  onSearch={onSearch}
                  hideDropdown={hideDropdown}
                />
              </div>
            )}
            {altFilter && (
              <>{typeof altFilter === "function" ? altFilter() : altFilter}</>
            )}
            {(!!onAddButtonClick || !sideBoxShown) &&
              allowUpsert &&
              primaryAddButton &&
              canModify && (
                <button type="button"
                  className={` flex items-center flex-row gap-2 ${addButtonClassName} h-12 z-10`}
                  onClick={onAddButtonClick}
                >
                  <AddIcon
                    sx={{
                      "&": {
                        color: "rgb(39,72,103)",
                        cursor: "pointer",
                      },
                    }}
                    fontSize="large"
                  />
                  {!!addButtonLabel && (
                    <span className=" text-base text-yardDeepBlue font-semibold ">
                      {addButtonLabel}
                    </span>
                  )}
                </button>
              )}
          </div>
          {typeof gridComponent === "function" ? gridComponent() : gridComponent}
        </div>
        {allowUpsert &&
          sideBoxShown &&
          (typeof upsertComponent === "function"
            ? upsertComponent()
            : upsertComponent)}
      </div>
    </div>
  );
};

export default ConfigurationShell;
